import { lazy, Suspense } from 'react'
import { useSearchParams } from 'react-router'

/**
 * Калитка дев-панели: проверяет `?debug=1` и только потом подгружает саму панель.
 *
 * Панель нужна и на проде — ей открывают состояния экранов на живом стенде, — поэтому
 * выключать её по `import.meta.env.DEV` нельзя. Но статический импорт затаскивал её,
 * реестр сценариев и всё, что она рендерит, в бандл входа: панель грузилась у всех и
 * всегда, а показывалась примерно никогда.
 *
 * Проверка флага живёт здесь, а не внутри `DevPanel`: там она сработала бы уже после
 * загрузки чанка, то есть ровно после того, чего мы избегаем.
 */
const DevPanel = lazy(() => import('./DevPanel').then((m) => ({ default: m.DevPanel })))

export function DevPanelGate() {
  const [searchParams] = useSearchParams()

  if (searchParams.get('debug') !== '1') {
    return null
  }

  return (
    <Suspense fallback={null}>
      <DevPanel />
    </Suspense>
  )
}
